export default "__VITE_ASSET__D4L9pVxh__"